import React from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const customToast = {
  position: "relative",
  display: "flex",
  justifyContent: "center",
  alignItems: "flex-start",
  maxWidth: 416,
  zIndex: 10,
  height: 90,
  padding: "20px 20px 20px 16px !important",
  margin: 24,
  border: "1px solid #E6E8EC",
  boxShadow: "0px 12px 32px 0px rgba(6, 28, 61, 0.08)",
  borderRadius: 10,
};

const Message = ({ title, desc }) => {
  return (
    <div className="space-y-[6px] font-monte">
      <h3
        style={{ color: "#0F1D40" }}
        className="text-sm font-semibold tracking-[-0.192px] md:text-base"
      >
        {title}
      </h3>
      {desc && (
        <div
          style={{ color: "#8991A3" }}
          className="text-xs font-medium md:text-sm"
        >
          {desc}
        </div>
      )}
    </div>
  );
};

export const CustomToastMessage = {
  success: (title, desc) => {
    toast.success(<Message title={title} desc={desc} />, {
      icon: <img src="/images/customToast/success.svg" alt="error icon" />,
      style: {
        ...customToast,
        borderLeft: "4px solid #0F9918",
      },
    });
  },
  warning: (title, desc) => {
    toast.warning(<Message title={title} desc={desc} />, {
      style: {
        ...customToast,
        borderLeft: "4px solid yellow",
      },
    });
  },
  error: (title, desc) => {
    toast.error(<Message title={title} desc={desc} />, {
      icon: (
        <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQZ8tK0cR6-G8ny0D13YCQo42vgrMCEmLQn7Q&s" />
      ),
      style: {
        ...customToast,
        zIndex: 10,
        borderLeft: "4px solid #E54545",
      },
      autoClose: false,
    });
  },
  info: (title, desc) => {
    toast.info(<Message title={title} desc={desc} />, {
      icon: <img src="/images/images/customToast/info.svg" />,
      style: {
        ...customToast,
        borderLeft: "4px solid #40A9FF",
      },
    });
  },
};
